import { Injector } from '@angular/core';
import { PermissionService } from '@services/permission.service';

import { PermissionsManager } from 'main/app-state/current-user/permissions/permissions.manager';
import { PermissionsService } from 'main/app-state/current-user/permissions/permissions.service';
import {
    iif,
    Observable,
    of,
} from 'rxjs';
import {
    catchError,
    map,
    shareReplay,
    switchMap,
    switchMapTo,
} from 'rxjs/operators';

import { isPermissionExpressionGranted } from '../permission-expression-parser';
import { FolderPermissionsAPI } from './permissions.api';

export class FolderPermissionsManager implements FolderPermissionsAPI {
    private _permissionsService: PermissionsService;
    private _cache: Record<string, Observable<string[] | null>> = {};
    private _allGlobalPermissions$: Observable<Set<string>>;

    constructor(
        injector: Injector,
        private _permissions: PermissionsManager,
    ) {
        this._permissionsService = injector.get<PermissionsService>(PermissionsService);
        this._allGlobalPermissions$ = injector.get<PermissionService>(PermissionService)
            .getPermissions()
            .pipe(
                map(permissions => new Set(permissions.filter(p => p.scope === 'Global').map(p => p.name))),
            );
    }

    public flushCache() {
        this._cache = {};
    }

    public isGranted = (folderId: number, permissionsExpression?: string): Observable<boolean> =>
        this._permissions.value$.pipe(
            switchMapTo(this._allGlobalPermissions$),
            switchMap(globalPermissions =>
                iif(
                    () => isPermissionExpressionGranted(
                        this._permissions.value!.filter(p => globalPermissions.has(p)),
                        permissionsExpression,
                    ),
                    of(true),
                    this._fetch(folderId).pipe(
                        map(permissions => isPermissionExpressionGranted(permissions || [], permissionsExpression)),
                    ),
                ),
            ),
        )

    private _fetch = (folderId: number) =>
        this._cache[folderId] ?
            this._cache[folderId] :
            this._cache[folderId] = this._permissionsService.get(folderId).pipe(
                catchError(_ => of([])),
                shareReplay(1),
            )
}
